interface LogoProps {
  size?: 'small' | 'large'
  alt?: string
  className?: string
}

const Logo = ({ size = 'small', alt = 'Impact Logo', className = '' }: LogoProps) => {
  const sizeConfig = {
    small: { width: 100, height: 25 },
    large: { width: 200, height: 50 }
  }

  const config = sizeConfig[size] || sizeConfig.small

  return (
    <img
      src="/impact_logo-1x.png"
      srcSet="/impact_logo-1x.png 1x, /impact_logo-2x.png 2x"
      alt={alt}
      width={config.width}
      height={config.height}
      loading="eager"
      fetchPriority="high"
      decoding="async"
      className={className}
    />
  )
}

export default Logo
